 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","1":"default~app-views-pages-accounts-reports-reports-module-ngfactory~app-views-pages-action-required-ac~3acdf62c","2":"default~app-views-pages-accounts-reports-reports-module-ngfactory~app-views-pages-action-required-ac~798352e0","3":"default~app-views-pages-accounts-reports-reports-module-ngfactory~app-views-pages-action-required-ac~32e18a16","4":"default~app-views-pages-accounts-reports-reports-module-ngfactory~app-views-pages-action-required-ac~35a78078","5":"default~app-views-pages-action-required-action-required-module-ngfactory~app-views-pages-admin-roles~8432714b","6":"default~app-views-pages-admin-roles-admin-roles-module-ngfactory~app-views-pages-cancel-resons-cance~3221e10a","7":"default~app-views-pages-action-required-action-required-module-ngfactory~app-views-pages-jobs-jobs-m~193f0491","8":"default~app-views-pages-customer-customer-module-ngfactory~app-views-pages-jobs-jobs-module-ngfactor~0328c847","9":"default~app-views-pages-cities-cities-module-ngfactory~app-views-pages-companies-companies-modules-n~09de09ce","11":"default~app-views-themes-default-theme-module-ngfactory~app-views-themes-demo2-theme-module-ngfactor~6b47fe9c","12":"default~app-views-themes-default-theme-module-ngfactory~app-views-themes-demo2-theme-module-ngfactor~ca332c2a","13":"default~app-views-pages-action-required-action-required-module-ngfactory~app-views-pages-packages-pa~54d479ae","14":"default~app-views-pages-customer-customer-module-ngfactory~customer-customer-details-customer-detail~5a3795bf","15":"default~app-views-pages-jobs-jobs-module-ngfactory~job-details-job-details-module-ngfactory","16":"default~app-views-themes-default-theme-module-ngfactory~app-views-themes-demo2-theme-module-ngfactor~e37c56cd","17":"app-views-pages-accounts-reports-reports-module-ngfactory","18":"app-views-pages-action-required-action-required-module-ngfactory","19":"app-views-pages-admin-roles-admin-roles-module-ngfactory","20":"app-views-pages-admin-users-admin-users-module-ngfactory","21":"app-views-pages-cancel-resons-cancel-resons-module-ngfactory","22":"app-views-pages-cancel-resons-customer-cancel-reasons-customer-cancel-reasons-module-ngfactory","23":"app-views-pages-cancelation-cancelation-module-ngfactory","24":"app-views-pages-categories-catagories-module-ngfactory","25":"app-views-pages-cities-cities-module-ngfactory","26":"app-views-pages-companies-companies-modules-ngfactory","27":"app-views-pages-coupons-coupon-module-ngfactory","28":"app-views-pages-customer-class-customer-class-module-ngfactory","29":"app-views-pages-customer-customer-module-ngfactory","30":"app-views-pages-customer-loyality-history-customer-loyality-module-ngfactory","31":"app-views-pages-customer-onlinetransction-customer-transction-module-ngfactory","32":"app-views-pages-customer-wallet-customer-wallet-module-ngfactory","33":"app-views-pages-dashboard-dashboard-module-ngfactory","34":"app-views-pages-default-time-slots-default-time-slots-module-ngfactory","35":"app-views-pages-jobs-jobs-module-ngfactory","36":"app-views-pages-localisation-localisation-module-ngfactory","37":"app-views-pages-loyality-settings-loyalitysetting-module-ngfactory","38":"app-views-pages-nationality-nationality-module-ngfactory","39":"app-views-pages-notifications-notifications-module-ngfactory","40":"app-views-pages-operation-performance-operation-performance-module-ngfactory","41":"app-views-pages-packages-packages-module-ngfactory","42":"app-views-pages-review-data-review-data-module-ngfactory","43":"app-views-pages-role-permissions-role-permission-module-ngfactory","44":"app-views-pages-settings-setting-module-ngfactory","45":"app-views-pages-special-coupon-specialcoupon-module-ngfactory","46":"app-views-pages-special-hours-special-hours-module-ngfactory","47":"app-views-pages-templates-template-module-ngfactory","48":"app-views-pages-transfer-request-transfer-request-module-ngfactory","49":"app-views-pages-users-reports-reports-module-ngfactory","50":"app-views-pages-vendor-class-vendor-class-module-ngfactory","51":"app-views-pages-vendor-loyality-setting-vendor-loyality-setting-module-ngfactory","52":"app-views-pages-vendor-online-transaction-vendoronlinetransction-module-ngfactory","53":"app-views-pages-vendor-role-vendor-role-module-ngfactory","54":"app-views-pages-vendor-wallet-vendor-wallet-module-ngfactory","55":"app-views-pages-vendors-vendors-module-ngfactory","56":"app-views-pages-zones-zones-module-ngfactory","57":"app-views-themes-default-content-builder-builder-module-ngfactory","58":"app-views-themes-default-theme-module-ngfactory","59":"app-views-themes-demo2-content-builder-builder-module-ngfactory","60":"app-views-themes-demo2-theme-module-ngfactory","61":"companies-details-compaines-details-compaines-module-ngfactory","62":"customer-customer-details-customer-details-module-ngfactory","63":"detail-adminuser-detail-adminuser-routing-module-ngfactory","65":"job-details-job-details-module-ngfactory","70":"vendors-vendor-details-vendor-details-module-ngfactory"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
